(function () {
  "use strict";

  const FIELD_CATALOG = [
    {
      key: "__row_status",
      label: "",
      type: "text",
      width: 55,
      readonly: true,
    },
    {
      key: "t_imdb_id",
      label: "IMDB ID",
      type: "text",
      width: 130,
      required: true,
    },
    {
      key: "__studio_id",
      label: "Studio ID",
      type: "text",
      width: 120,
    },
    {
      key: "__title_id",
      label: "Title ID",
      type: "text",
      width: 100,
      readonly: true,
    },
    {
      key: "__import_destination",
      label: "Import To",
      type: "dropdown_static",
      width: 120,
      options: ["SD", "SD for BST"],
      defaultValue: "SD",
    },
    {
      key: "t_title",
      label: "Title",
      type: "text",
      width: 260,
      required: true,
    },
    { key: "t_year_completed", label: "Year", type: "numeric", width: 80 },
    { key: "t_runtime", label: "Runtime", type: "text", width: 100 },
    {
      key: "t_short_synopsis",
      label: "Short Synopsis",
      type: "text",
      width: 320,
    },
    {
      key: "t_medium_synopsis",
      label: "Medium Synopsis",
      type: "text",
      width: 360,
    },
    {
      key: "t_long_synopsis",
      label: "Long Synopsis",
      type: "text",
      width: 420,
    },
    { key: "t_language", label: "Language", type: "text", width: 120 },
    {
      key: "t_status",
      label: "Status",
      type: "dropdown",
      optionsKey: "statuses",
      width: 170,
    },
    {
      key: "t_internal_status",
      label: "Internal Status",
      type: "dropdown",
      optionsKey: "internal_statuses",
      width: 190,
    },
    {
      key: "t_approval_status",
      label: "Approval",
      type: "dropdown",
      optionsKey: "approval_statuses",
      width: 160,
    },
    {
      key: "t_title_type",
      label: "Title Type",
      type: "dropdown",
      optionsKey: "title_types",
      width: 160,
    },
    {
      key: "t_rating",
      label: "Rating",
      type: "dropdown",
      optionsKey: "ratings",
      width: 130,
    },
    {
      key: "t_original_format",
      label: "Original Format",
      type: "dropdown",
      optionsKey: "formats",
      width: 170,
    },
    {
      key: "t_genres",
      label: "Genres",
      type: "multiselect",
      optionsKey: "genres",
      width: 180,
    },
    {
      key: "t_labels",
      label: "Labels",
      type: "multiselect",
      optionsKey: "labels",
      width: 180,
    },
    {
      key: "t_territories",
      label: "Territories",
      type: "multiselect",
      optionsKey: "territories",
      width: 140,
    },
    {
      key: "t_sales_commission",
      label: "Sales Commission",
      type: "numeric",
      width: 150,
    },
    {
      key: "t_distribution",
      label: "Distribution",
      type: "numeric",
      width: 130,
    },
    { key: "t_advance", label: "Advance", type: "numeric", width: 120 },
    {
      key: "t_flat_marketing",
      label: "Flat Marketing",
      type: "numeric",
      width: 150,
    },
    { key: "t_interest", label: "Interest", type: "numeric", width: 120 },
    { key: "t_cap", label: "Cap", type: "numeric", width: 120 },
    { key: "t_release_date", label: "Release Date", type: "date", width: 130 },
    { key: "t_avail_start", label: "Avail Start", type: "date", width: 130 },
    { key: "t_avail_end", label: "Avail End", type: "date", width: 130 },
    { key: "t_exclusive", label: "Exclusive", type: "checkbox", width: 95 },
    { key: "t_director", label: "Director", type: "text", width: 180 },
    { key: "t_writer", label: "Writer", type: "text", width: 180 },
    { key: "t_producer", label: "Producer", type: "text", width: 180 },
    { key: "t_cast", label: "Cast", type: "text", width: 240 },
    {
      key: "t_exec_producers",
      label: "Exec Producers",
      type: "text",
      width: 220,
    },
    {
      key: "t_video_trailer_1",
      label: "Trailer URL",
      type: "text",
      width: 260,
    },
    { key: "t_site", label: "Website", type: "text", width: 220 },
    { key: "t_facebook", label: "Facebook", type: "text", width: 180 },
    { key: "t_twitter", label: "Twitter", type: "text", width: 180 },
    { key: "t_instagram", label: "Instagram", type: "text", width: 180 },
    { key: "t_notes", label: "Notes", type: "text", width: 260 },
    {
      key: "t_internal_notes",
      label: "Internal Notes",
      type: "text",
      width: 260,
    },
  ];

  function normalizeOptions(lookups, key) {
    const source = lookups && Array.isArray(lookups[key]) ? lookups[key] : [];
    return source
      .map((item) => {
        if (
          item &&
          typeof item === "object" &&
          Object.prototype.hasOwnProperty.call(item, "value")
        ) {
          return {
            value: item.value,
            label:
              item.label !== undefined && item.label !== null
                ? String(item.label)
                : String(item.value),
          };
        }

        return {
          value: item,
          label: String(item),
        };
      })
      .filter((item) => item.label.length > 0);
  }

  function getValueMap(lookups, key) {
    const options = normalizeOptions(lookups, key);
    const map = {};
    options.forEach((item) => {
      map[String(item.value)] = item.label;
    });
    return map;
  }

  function getLabelMap(lookups, key) {
    const options = normalizeOptions(lookups, key);
    const map = {};
    options.forEach((item) => {
      map[item.label.toLowerCase()] = item.value;
    });
    return map;
  }

  function toArray(value) {
    if (Array.isArray(value)) {
      return value;
    }

    if (typeof value === "string") {
      const trimmed = value.trim();
      if (!trimmed) {
        return [];
      }

      if (trimmed.startsWith("[") && trimmed.endsWith("]")) {
        try {
          const parsed = JSON.parse(trimmed);
          return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          return [];
        }
      }

      return trimmed
        .split(",")
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0);
    }

    if (value === undefined || value === null || value === "") {
      return [];
    }

    return [value];
  }

  function mapValueToLabel(value, lookups, key) {
    if (value === undefined || value === null || value === "") {
      return null;
    }

    const map = getValueMap(lookups, key);
    const raw = String(value);
    return Object.prototype.hasOwnProperty.call(map, raw) ? map[raw] : raw;
  }

  function mapLabelToValue(value, lookups, key) {
    if (value === undefined || value === null || value === "") {
      return null;
    }

    const options = normalizeOptions(lookups, key);
    const map = getLabelMap(lookups, key);
    const raw = String(value).trim();
    const lower = raw.toLowerCase();

    if (Object.prototype.hasOwnProperty.call(map, lower)) {
      return map[lower];
    }

    const normalizedInput = lower.replace(/[^a-z0-9]+/g, " ").trim();
    for (let i = 0; i < options.length; i += 1) {
      const option = options[i];
      const optionLabel = option.label.toLowerCase();
      const normalizedLabel = optionLabel.replace(/[^a-z0-9]+/g, " ").trim();
      if (
        normalizedLabel === normalizedInput ||
        normalizedLabel.indexOf(normalizedInput) !== -1 ||
        normalizedInput.indexOf(normalizedLabel) !== -1
      ) {
        return option.value;
      }
    }

    return null;
  }

  function normalizeNumeric(value, integerOnly) {
    if (value === undefined || value === null || value === "") {
      return null;
    }

    if (typeof value === "number" && Number.isFinite(value)) {
      return integerOnly ? Math.trunc(value) : value;
    }

    const normalized = String(value).replace(/,/g, "").trim();
    if (!normalized) {
      return null;
    }

    const parsed = Number(normalized);
    if (Number.isNaN(parsed)) {
      return value;
    }

    return integerOnly ? Math.trunc(parsed) : parsed;
  }

  function normalizeMultiselectDisplay(value, lookups, key) {
    const source = toArray(value);
    if (source.length === 0) {
      return [];
    }

    return source.map((entry) => mapValueToLabel(entry, lookups, key));
  }

  function normalizeMultiselectSave(value, lookups, key) {
    const source = toArray(value);
    if (source.length === 0) {
      return [];
    }

    return source
      .map((entry) => mapLabelToValue(entry, lookups, key))
      .filter((entry) => entry !== null && entry !== undefined && entry !== "");
  }

  function multiselectRenderer(
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties
  ) {
    const labels = toArray(value).map((entry) => String(entry));
    const text =
      prop === "t_territories" && labels.length > 3
        ? `${labels.slice(0, 2).join(", ")} +${labels.length - 2}`
        : labels.join(", ");

    const renderer =
      window.Handsontable &&
      window.Handsontable.renderers &&
      window.Handsontable.renderers.TextRenderer;

    if (renderer) {
      renderer(instance, td, row, col, prop, text, cellProperties);
    } else {
      td.textContent = text;
    }

    td.title = labels.join(", ");
  }

  const STATUS_ICON_MAP = {
    "": { icon: "", cls: "", html: false },
    "Loading...": {
      icon: "...",
      cls: "ht-status-loading",
      html: false,
    },
    "Loaded (new)": { icon: "NEW", cls: "ht-status-new", html: false },
    "Loaded (update)": { icon: "EDIT", cls: "ht-status-update", html: false },
    Error: { icon: "✕", cls: "ht-status-error", html: false },
    "Save failed": { icon: "✕", cls: "ht-status-error", html: false },
    "Not found": { icon: "?", cls: "ht-status-notfound", html: false },
    "Saving...": {
      icon: '<span class="ht-spinner"></span>',
      cls: "ht-status-loading",
      html: true,
    },
    Saved: { icon: "✔", cls: "ht-status-saved", html: false },
    "Saved (updated)": { icon: "✔", cls: "ht-status-saved", html: false },
    "Saved (created)": { icon: "✔", cls: "ht-status-saved", html: false },
    Failed: { icon: "✕", cls: "ht-status-error", html: false },
  };

  function statusRenderer(
    _instance,
    td,
    _row,
    _col,
    _prop,
    value,
    _cellProperties
  ) {
    const isObject = value && typeof value === "object";
    const text = isObject
      ? value.text === null || value.text === undefined
        ? ""
        : String(value.text)
      : value === null || value === undefined
      ? ""
      : String(value);
    const detail = isObject
      ? value.detail === null || value.detail === undefined
        ? ""
        : String(value.detail)
      : "";
    const entry = STATUS_ICON_MAP[text] || {
      icon: text.slice(0, 3),
      cls: "ht-status-unknown",
      html: false,
    };
    if (entry.html) {
      td.innerHTML = entry.icon;
    } else {
      td.textContent = entry.icon;
    }
    td.title = detail || text;
    td.className = "htMiddle htCenter htReadOnly";
    if (entry.cls) {
      td.classList.add(entry.cls);
    }
    td.style.cursor = detail ? "help" : "default";
    td.onclick = null;
    if (detail) {
      td.onclick = () => {
        window.alert(detail);
      };
    }
  }

  function createColumns(lookups) {
    return FIELD_CATALOG.map((field) => {
      if (field.type === "dropdown_static") {
        return {
          data: field.key,
          type: "autocomplete",
          source: field.options || [],
          strict: true,
          allowInvalid: false,
          filter: false,
        };
      }

      if (field.type === "dropdown") {
        const options = normalizeOptions(lookups, field.optionsKey);
        return {
          data: field.key,
          type: "autocomplete",
          source: options.map((option) => option.label),
          strict: true,
          allowInvalid: false,
          filter: true,
          trimDropdown: true,
        };
      }

      if (field.type === "multiselect") {
        const options = normalizeOptions(lookups, field.optionsKey);
        return {
          data: field.key,
          type: "multiselect",
          source: options.map((option) => option.label),
          searchInput: true,
          allowEmpty: true,
          renderer: multiselectRenderer,
        };
      }

      if (field.type === "numeric") {
        if (field.key === "t_year_completed") {
          return {
            data: field.key,
            type: "numeric",
            numericFormat: {
              pattern: "0",
              culture: "en-US",
            },
            allowEmpty: true,
          };
        }

        return {
          data: field.key,
          type: "numeric",
          numericFormat: {
            pattern: "0,0.00",
            culture: "en-US",
          },
          allowEmpty: true,
        };
      }

      if (field.type === "date") {
        return {
          data: field.key,
          type: "date",
          dateFormat: "YYYY-MM-DD",
          correctFormat: true,
          allowEmpty: true,
        };
      }

      if (field.type === "checkbox") {
        return {
          data: field.key,
          type: "checkbox",
          checkedTemplate: true,
          uncheckedTemplate: false,
        };
      }

      if (field.key === "__row_status") {
        return {
          data: field.key,
          type: "text",
          readOnly: true,
          renderer: statusRenderer,
          columnSorting: { headerAction: false },
        };
      }

      return {
        data: field.key,
        type: "text",
        readOnly: !!field.readonly,
      };
    });
  }

  function createHeaders() {
    return FIELD_CATALOG.map((field) => field.label);
  }

  function createDataFields() {
    return FIELD_CATALOG.map((field) => field.key);
  }

  function createColumnWidths() {
    return FIELD_CATALOG.map((field) => field.width || 150);
  }

  function toDisplayRow(row, lookups) {
    const result = {};
    FIELD_CATALOG.forEach((field) => {
      const value =
        row && Object.prototype.hasOwnProperty.call(row, field.key)
          ? row[field.key]
          : null;

      if (field.type === "dropdown") {
        result[field.key] = mapValueToLabel(value, lookups, field.optionsKey);
        return;
      }

      if (field.type === "multiselect") {
        result[field.key] = normalizeMultiselectDisplay(
          value,
          lookups,
          field.optionsKey
        );
        return;
      }

      if (field.type === "dropdown_static") {
        result[field.key] = value || field.defaultValue || null;
        return;
      }

      if (field.key === "t_year_completed") {
        result[field.key] = normalizeNumeric(value, true);
        return;
      }

      result[field.key] = value;
    });

    return result;
  }

  function toSaveRow(row, lookups) {
    const result = {};
    FIELD_CATALOG.forEach((field) => {
      if (field.key === "__row_status") {
        return;
      }

      if (field.key === "__studio_id" || field.key === "__title_id") {
        return;
      }

      if (field.key === "__import_destination") {
        return;
      }

      const value =
        row && Object.prototype.hasOwnProperty.call(row, field.key)
          ? row[field.key]
          : null;

      if (field.type === "dropdown") {
        result[field.key] = mapLabelToValue(value, lookups, field.optionsKey);
        return;
      }

      if (field.type === "multiselect") {
        result[field.key] = normalizeMultiselectSave(
          value,
          lookups,
          field.optionsKey
        );
        return;
      }

      if (field.key === "t_year_completed") {
        result[field.key] = normalizeNumeric(value, true);
        return;
      }

      result[field.key] = value;
    });

    return result;
  }

  window.BulkTitleHotConfig = {
    catalog: FIELD_CATALOG,
    createColumns,
    createHeaders,
    createDataFields,
    createColumnWidths,
    toDisplayRow,
    toSaveRow,
  };
})();
